import React from "react";
import PhotoUploader from "@/components/visit/PhotoUploader";
import { sectionFiles } from "@/lib/visitSchema";

export default function KhasraStep({ form, uploads }) {
  return (
    <div className="space-y-4" data-testid="visit-step-khasra-panel">
      <p className="text-xs text-slate-500">Upload the Khasra Milan / map alignment proof: khasra map or Jamabandi extract alongside a photo of the plot boundary so the office can confirm the property matches the record.</p>
      <PhotoUploader section="khasra" label="Khasra Milan / map alignment documents" accept="image/*,application/pdf"
        files={sectionFiles(form, "khasra")} uploads={uploads} testId="visit-upload-khasra" />
    </div>
  );
}
